import { render, staticRenderFns } from "./institucional.vue?vue&type=template&id=2852ce5f&"
import script from "./institucional.vue?vue&type=script&lang=js&"
export * from "./institucional.vue?vue&type=script&lang=js&"
import style0 from "./institucional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/opt/buildhome/repo/components/Banner.vue').default,HomeProdutosItems: require('/opt/buildhome/repo/components/Home/ProdutosItems.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
